import { SET_AUTHORIZED } from 'vx/mutations'
import store from 'vx/store'
import router from './../router'
import storage from 'store'

export default {
  /**
   * Redirect to login if token expires without refreshing.
   *
   * @return void
   */
  redirectOnTokenExpired () {
    this.clearToken()

    store.commit(`user/${SET_AUTHORIZED}`, false)

    router.push({ name: 'auth.login', query: { redirect: router.currentRoute.path } })
  },

  /**
   * Update JWT from the authorization header of a response.
   *
   * @param string authorization
   *
   * @return void
   */
  updateTokenFromHeader (authorization) {
    if (authorization !== undefined) {
      storage.set('token', authorization.substring(7))
    }
  },

  /**
   * Get the token from local storage.
   *
   * @return string
   */
  getToken () {
    return storage.get('token')
  },

  /**
   * Determine if we have a token in local storage.
   *
   * @return boolean
   */
  hasToken () {
    return this.getToken() !== null
  },

  /**
   * Check if we are logged in.
   *
   * @return boolean
   */
  check () {
    return store.state.user.authorized !== false
  },

  getGoogleQR () {
    return store.dispatch('user/googleQRCode').then(response => {
      return response
    })
  },

  /**
   * Attempt to log a user in.
   *
   * @param string email
   * @param string password
   *
   * @return Promise
   */
  attempt (email, password, googleToken) {
    return store.dispatch('user/login', { email, password, token: googleToken }).then(response => {
      storage.set('token', response.data.token)

      return response
    })
  },

  /**
   * Attempt to authenticate via a stored token if we have one.
   *
   * @return Promise
   */
  fromToken () {
    return new Promise((resolve, reject) => {
      let token = this.getToken()

      // If the user is authorized already then we can just resolve this promise
      // as we do not need to fetch their details again.
      if (this.check()) {
        resolve()

      // If we do not have a token from local storage then we are unable to
      // authorize the user so we'll reject the promise.
      } else if (token === undefined || token === null) {
        reject(new Error('Could not resolve token from local storage.'))

      // We can now authorize the initial request by dispatching the authorize
      // action with the token we have.
      } else {
        store.dispatch('user/authorize', token)
          .then(resolve)
          .catch(() => {
            reject(new Error('Unable to authorize with token provided by local storage.'))
          })
      }
    })
  },

  /**
   * Clear the token from local storage.
   *
   * @return void
   */
  clearToken () {
    storage.remove('token')
  }
}
